var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("We are refactoring PRESENTA from the ground up"),_c('br'),_vm._v(" and it's going to take a while.")]),_c('p',[_vm._v("If you already have an account, we'll notify you when it'll be online again. Thanks!")])])
}]

export { render, staticRenderFns }